import {openTransferDrawer} from "../helpers/DrawerActions";
import {apiGetChargeHistory, apiGetSmsHistory} from "api/smsPanelApi";
import {DateToString} from "components/Reports/DateFilter";
import {StatusComponent} from "components/Table/CellComponents";

const defaultTableColumns = [
    {
        name: "تاریخ",
        key: "date",
        size: "4",
        searchType: "date",
    },
    {
        name: "ساعت",
        key: "time",
        size: "4",
        searchType: "default",
    },
    {
        name: "مبلغ",
        key: "price",
        price: true,
        size: "3",
        mainColumn: true,
        searchType: "quantitative",
        colorLess: true,
    },
    {
        name: "وضعیت",
        key: "status",
        Component: StatusComponent,
        size: "3",
        mainColumn: true,
        searchType: "status",
        dataKey: [
            {label: "موفق", value: "1", id: 1},
            {label: "ناموفق", value: "0", id: 2},
        ],
    },
];

const historyTableColumns = [
    {
        name: "تاریخ",
        key: "date",
        size: "4",
        searchType: "date",
        disableSearch: true,
        getValue: (item) => DateToString(new Date(item.createdAt)),
    },
    {
        name: "ساعت",
        key: "hour",
        size: "4",
        searchType: "date",
        disableSearch: true,
        getValue: (item) => Intl.DateTimeFormat("fa-IR-u-nu-latn", {timeStyle: "short"}).format(new Date(item.createdAt)),
    },
    {
        name: "متن پیام",
        key: "description",
        size: "4",
        searchType: "default",
        disableSearch: true,
    },
    {
        name: "شماره موبایل",
        key: "phone",
        size: "4",
        searchType: "default",
        disableSearch: true,
    },
    {
        name: "وضعیت",
        key: "status",
        Component: StatusComponent,
        size: "3",
        disableSearch: true,
        searchType: "status",
        dataKey: [
            {label: "موفق", value: "1", id: 1},
            {label: "ناموفق", value: "0", id: 2},
        ],
    },
    {
        name: "تعداد پیامک",
        key: "count",
        size: "4",
        searchType: "default",
        disableSearch: true,
    },
    {
        name: "مبلغ کل",
        key: "price",
        size: "4",
        searchType: "default",
        disableSearch: true,
    },
];

export const smsIndexData = [
    {
        title: "همه",
        description: "",
        key: "smsPanel",
        label: "پنل پیامکی",
        pluralLabel: "پنل پیامکی",
        pageTitle: "پنل پیامکی",
        pageDescription: "پنل ارسال پیامک های حسابداری",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده پیامک",
                openDrawer: openTransferDrawer,
            },
            fetch: apiGetChargeHistory,
            // delete: apiDeleteTransfers,
            copy: false,
            // excel: {
            //   export: apiGetTransfersExcel,
            // },
        },
    },
];

export const smsHistoryIndexData = [
    {
        title: "همه",
        description: "",
        key: "smsHistory",
        label: "تاریخچه",
        pluralLabel: "تاریخچه پیامک",
        pageTitle: "تاریخچه پیامک",
        pageDescription: "تاریخچه پیامک های ارسال شده",
        tableColumns: historyTableColumns,
        disableDateFilter: true,
        actions: {
            fetch: apiGetSmsHistory,
            copy: false,
        },
    },
];
